var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "asc__header" },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("div", { staticClass: "asc__header-otherApps" }, [
                _c("img", {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle.sidebar-1",
                      modifiers: { "sidebar-1": true }
                    }
                  ],
                  attrs: {
                    id: "otherAppsImg",
                    src: require("../../static/otherApps.svg")
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "asc__header-logo",
                  attrs: { to: { name: "Dashboard" } }
                },
                [_c("img", { attrs: { src: _vm.logo.header } })]
              ),
              _vm._v(" "),
              _c("Shortcuts", { staticClass: "d-none d-lg-inline-block" })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass:
                "asc__header-userBox d-flex align-items-center justify-content-end",
              attrs: { cols: "2", md: "4", lg: "2" }
            },
            [
              _c(
                "b-dropdown",
                {
                  staticClass: "d-none d-lg-inline-block",
                  attrs: {
                    right: "",
                    id: "asc__header-userBox",
                    variant: "white"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "button-content",
                      fn: function() {
                        return [
                          _c("i", { staticClass: "fas fa-network-wired" }),
                          _vm._v(
                            " " + _vm._s(_vm.loginUser.branch) + "\n        "
                          )
                        ]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _vm._v(" "),
                  _c(
                    "b-dropdown-header",
                    { attrs: { id: "dropdown-header-label" } },
                    [
                      _c("i", { staticClass: "fas fa-network-wired" }),
                      _vm._v(
                        " " + _vm._s(_vm.$t("general.branches")) + "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("b-form-input", {
                        attrs: { placeholder: _vm.$t("nav.search") },
                        model: {
                          value: _vm.searchBranch,
                          callback: function($$v) {
                            _vm.searchBranch = $$v
                          },
                          expression: "searchBranch"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.filteredUserBranches, function(branch, i) {
                    return _c(
                      "b-dropdown-item",
                      {
                        key: "branch" + i,
                        on: {
                          click: function($event) {
                            return _vm.changeBranch(branch)
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "\n            " +
                              _vm._s(branch.Desciption) +
                              "\n          "
                          )
                        ])
                      ]
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-dropdown",
                {
                  staticClass: "d-none d-md-inline-block",
                  attrs: {
                    right: "",
                    id: "asc__header-userBox",
                    variant: "white"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "button-content",
                      fn: function() {
                        return [
                          _c("i", { staticClass: "far fa-user" }),
                          _vm._v(
                            " " + _vm._s(_vm.loginUser.name) + "\n        "
                          )
                        ]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    { attrs: { to: { name: "ChangePassword" } } },
                    [
                      _c("i", { staticClass: "fa fa-key" }),
                      _vm._v(" " + _vm._s(_vm.$t("nav.changePassword")))
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    {
                      on: {
                        click: function($event) {
                          return _vm.changeLang()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-language" }),
                      _vm._v(" " + _vm._s(_vm.toggleLang))
                    ]
                  ),
                  _vm._v(" "),
                  _c("b-dropdown", {
                    staticClass: "inline-menu d-none d-md-inline-block",
                    attrs: { variant: "menu" },
                    nativeOn: {
                      "!click": function($event) {
                        $event.stopPropagation()
                        _vm.showSecondMenu = !_vm.showSecondMenu
                      }
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "button-content",
                        fn: function() {
                          return [
                            _c("i", { staticClass: "fa fa-cog" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("nav.settings")) +
                                "\n          "
                            )
                          ]
                        },
                        proxy: true
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _vm.showSecondMenu
                    ? _c(
                        "ul",
                        { staticClass: "sub-menu" },
                        [
                          _c(
                            "b-dropdown-item",
                            { attrs: { to: { name: "ChangePassword" } } },
                            [
                              _c("i", { staticClass: "fa fa-key" }),
                              _vm._v(" " + _vm._s(_vm.$t("nav.changePassword")))
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            { attrs: { to: { name: "StockChangePassword" } } },
                            [
                              _c("i", { staticClass: "fa fa-key" }),
                              _vm._v(
                                " " + _vm._s(_vm.$t("nav.stockChangePassword"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("b-dropdown-divider"),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    {
                      on: {
                        click: function($event) {
                          return _vm.logoutHeader()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-sign-out-alt" }),
                      _vm._v(" " + _vm._s(_vm.$t("nav.logout")))
                    ]
                  ),
                  _vm._v(" "),
                  _c("b-dropdown-divider"),
                  _vm._v(" "),
                  _c("b-dropdown-item", { staticClass: "text-center" }, [
                    _c("p", { staticClass: "asc__auth-idea-verno" }, [
                      _c("span", [_vm._v("V")]),
                      _vm._v(" " + _vm._s(_vm.system.version))
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "position-relative d-none" },
                [
                  _c("span", { staticClass: "asc__count" }, [
                    _vm._v(_vm._s(_vm.notify.length))
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-dropdown",
                    {
                      staticClass: "asc__notification",
                      attrs: { size: "lg", "no-caret": "" },
                      scopedSlots: _vm._u([
                        {
                          key: "button-content",
                          fn: function() {
                            return [_c("i", { staticClass: "fa fa-bell" })]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "b-dropdown-header",
                        { attrs: { id: "dropdown-header-label" } },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex justify-content-between" },
                            [
                              _c("span", [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm.$t("general.notifications"))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("general.notifyItems", {
                                        x: _vm.notify.length
                                      })
                                    )
                                  )
                                ])
                              ])
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.notify, function(row, i) {
                        return _c(
                          "b-dropdown-item",
                          { key: i, staticClass: "asc__dropdown-item" },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-modal",
                                    rawName: "v-b-modal.notificationModal",
                                    modifiers: { notificationModal: true }
                                  }
                                ],
                                on: {
                                  click: function($event) {
                                    return _vm.openModal(row.title, row.content)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(row.title))]
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("i", {
                directives: [
                  {
                    name: "b-toggle",
                    rawName: "v-b-toggle.sidebar-right",
                    modifiers: { "sidebar-right": true }
                  }
                ],
                staticClass: "fa fa-star d-none",
                attrs: { id: "shortcutsIcon" }
              }),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass:
                    "d-inline-block d-lg-none float-right text-light",
                  attrs: { variant: "default" },
                  on: {
                    click: function($event) {
                      return _vm.collapseNav()
                    }
                  }
                },
                [_c("i", { class: _vm.hamburgerIcon })]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            { attrs: { id: "notificationModal", title: _vm.modalHeader } },
            [
              _c("p", { staticClass: "my-4" }, [
                _vm._v(_vm._s(_vm.modalContent))
              ])
            ]
          ),
          _vm._v(" "),
          _c("Sidebar"),
          _vm._v(" "),
          _c("sidebar-right")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61dd7a3d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61dd7a3d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = null
// module chunks = 